<template>
  <b-modal v-model="visible" :title="title" @ok="onOk" @show="onShow">
    <b-form @submit.prevent="onSubmit">
      <b-form-group class="required" label="Nazwa">
        <b-form-input
          v-model="name"
          :state="$v.name.$error? false : null"
          @input="$v.name.$reset()"
          type="text"
          autocomplete="off"
        />
        <b-form-invalid-feedback>
          <div v-if="!$v.name.required">To pole jest wymagane</div>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group class="required" label="Poziom zaawansowania">
        <b-form-select
          v-model="languageProficiency"
          :options="languageProficiencies"
          :state="$v.languageProficiency.$error? false : null"
        ></b-form-select>
        <b-form-invalid-feedback>
          <div v-if="!$v.languageProficiency.required">To pole jest wymagane</div>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group class="required" label="Opis">
        <b-form-textarea
          v-model="description"
          :state="$v.description.$error? false : null"
          @input="$v.description.$reset()"
          rows="3"
          max-rows="6"
          autocomplete="off"
        />
        <b-form-invalid-feedback>
          <div v-if="!$v.description.required">To pole jest wymagane</div>
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
// import { axios, eventBus } from "@/_infrastructure";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      visible: false,
      name: null,
      description: null,
      languageProficiency: null,
      languageProficiencies: [
        { value: 0, text: this.$options.filters.languageProficiency(0) },
        { value: 1, text: this.$options.filters.languageProficiency(1) },
        { value: 6, text: this.$options.filters.languageProficiency(6) },
        { value: 2, text: this.$options.filters.languageProficiency(2) },
        { value: 3, text: this.$options.filters.languageProficiency(3) },
        { value: 4, text: this.$options.filters.languageProficiency(4) },
        { value: 5, text: this.$options.filters.languageProficiency(5) }
      ]
    };
  },
  computed: {
    title() {
      if (this.course) {
        return "Edycja kursu";
      } else {
        return "Utwórz nowy kurs";
      }
    }
  },
  props: ["course"],
  validations: {
    name: { required },
    languageProficiency: { required },
    description: { required }
  },
  methods: {
    show() {
      this.visible = true;
    },
    onShow() {
      this.$v.$reset();

      if (this.course) {
        this.name = this.course.name;
        this.description = this.course.description;
        this.languageProficiency = this.course.languageProficiency;
      } else {
        this.name = null;
        this.description = null;
        this.languageProficiency = null;
      }
    },
    onOk(e) {
      e.preventDefault();
      this.onSubmit();
    },
    onSubmit() {
      this.$v.$touch();

      if (!this.$v.$error) {
        let result = {
          name: this.name,
          description: this.description,
          languageProficiency: this.languageProficiency
        };

        this.$emit("save", result);
        this.visible = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

